import React, {PureComponent, ReactNode} from 'react'
import {connect} from 'react-redux'
import {TFunction, withTranslation} from 'react-i18next';
import {State} from "@App/state";
import {Organization} from "@App/types";
import {Organizations} from "@App/types/enums";

type ContactPartnerProps = {
    t: TFunction // translation method from withTranslation HOC from i18next
    organization: Organization
}

const mapStateToProps = (state: State) => ({
    organization: state.orders.organization
})

export class ContactPartnerComponent extends PureComponent<ContactPartnerProps> {

    render(): ReactNode {

        const t = this.props.t
        const organization = this.props.organization

        return (
            <div>
                <div className="text-2xl font-serif text-neutral-700 mb-3">{t('contact.title')}</div>
                <p>{t('contact.partner-text', {organization: organization.name})}</p>
                <div className="flex gap-2 mt-3">
                    <img className="max-w-[70px] max-h-[70px] md:max-w-[96px] md:max-h-[96px]"
                         src="/images/brand/db.svg" alt=""/>
                    <table>
                        <tbody className="align-center">
                        <tr>
                            <td className="w-[60px] text-sm md:text-base leading-6">{t('contact.phone')}</td>
                            <td>
                                <a className="text-neutral-700 no-underline" href="tel:00496922220332332">+49 69 2222 0332 332</a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

// Connect the component to the Redux store
const ConnectedComponent = connect(mapStateToProps)(ContactPartnerComponent)
export const ContactPartner = withTranslation()(ConnectedComponent)

